// Angular Files
import { CommonModule, KeyValuePipe } from '@angular/common';
import {
 Component, NgModule, Inject, OnInit, OnDestroy, DOCUMENT
} from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';

// Angular Material Files
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';

// Teller Online Library Files
import { TellerOnlineIconsModule } from 'teller-online-libraries/icons';
// Deep-path imports break a barrel cycle: shared/index.ts evaluates lib/components
// before lib/services, but lib/services/message.service.ts also pulls in this file —
// barrel-importing services back here under Vite ESM left TellerOnlineMessageService
// undefined in the shared namespace and crashed R3Injector.get. Dialog model types
// live in a sibling file to avoid re-entering message.service from this component.
import { TellerOnlineDialogOptions } from './dialog.types';
import { TellerOnlineValidationService } from '../../services/validation.service';
import { TellerOnlineWindowService } from '../../services/window.service';
import { DirectivesModule } from '../../directives/directives.module';
import { PipesModule } from '../../pipes/pipes.module';

@Component({
    selector: 'teller-online-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    host: {
        class: 'dialog'
    },
    standalone: false
})
export class TellerOnlineDialogComponent implements OnInit, OnDestroy {
    public formData = {};

    public columnDefinitions = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: TellerOnlineDialogOptions,
        @Inject(DOCUMENT) public document: Document,
        public validationService: TellerOnlineValidationService,
        private windowService: TellerOnlineWindowService,
        private dialogRef: MatDialogRef<TellerOnlineDialogComponent>
    ) {
    }

    ngOnInit(): void {
        this.data.tables?.forEach(table => {
            const header = [];
            for (let i = 0; i < table.rows[0].length; i++) {
                header.push(`column_${i}`);
            }
            this.columnDefinitions.push(header);
        });

        // class added here to allow proper printing styling, removed in ngOnDestroy()
        this.document.querySelector('body').classList.add('dialog-opened');
    }

    ngOnDestroy(): void {
        this.document.querySelector('body').classList.remove('dialog-opened');
    }

    onClick_actionClose(closeModal: boolean, form: NgForm, callback: Function): void {
         if (callback) {
            callback();

            if (closeModal) {
                this.dialogRef.close(closeModal);
            }
        } else if (this.data.form && closeModal) {
            if (!this.validationService.runValidation(form)) return;

            // update the close value to be the formdata
            this.dialogRef.close(this.formData);
        } else {
            this.dialogRef.close(closeModal);
        }
    }
}
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DirectivesModule,
        TellerOnlineIconsModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatTableModule,
        MatIconModule,
        KeyValuePipe,
        PipesModule
    ],
    declarations: [TellerOnlineDialogComponent],
    exports: [TellerOnlineDialogComponent]
})
export class TellerOnlineDialogModule { }
